import dayjs from 'dayjs';
import { getTitle } from '../helper';
import { Link } from 'react-router-dom';

export const HistoryItem = ({
  score,
  levels,
  creationDate,
  id,
  title,
}: {
  score: number;
  levels: {
    [score: number]: {
      title: string;
      color: string;
    };
  };
  creationDate: string;
  id: string;
  title: string;
}) => {
  const date = dayjs(creationDate).format('D MMMM YYYY');

  return (
    <Link
      to={`${id}`}
      state={{ levels, title: `${title}: ${date}` }}
      className="bg-card flex items-center rounded-lg px-4 py-3"
    >
      <div className="mr-4 text-[30px] font-bold">{score}</div>
      <div>
        <div className="mb-1">{getTitle({ levels, score: score })}</div>
        <div className="text-sm">{date}</div>
      </div>
    </Link>
  );
};
